import React from "react";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import MaterialTable from 'material-table';
import ls from 'local-storage';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  tabBar: {
    boxShadow: 'none',
    paddingTop: 8,
  },
  gridStyle: {
      padding: 2,
      backgroundColor: "",
  },
  batchList: {
    position: 'relative',
    overflow: 'auto',
    maxHeight: `calc(100vh - 200px)`,
  }
});

class ClaimsSchedules extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.props = props;
    }

    state = {
        schedulelist: [],
        scheduleclaimlist: []
    };

    getMuiTheme = () => createMuiTheme({
        overrides: {
            MuiTableCell: {
                root: {
                    padding: 0,
                }
            },
            MUIDataTable: {
                responsiveScroll: {
                    paddingLeft: 8,
                    maxHeight: `calc(100vh - 145px)`,
                },
            },
        }
    });  

    fetchSchedules() {
        if (this._isMounted) {
            this.props.socket.emit("claims_schedule_list",{authenticator:ls.get("authenticator")});
        }
    };

    fetchScheduleClaims() {
        if (this._isMounted) {
            this.props.socket.emit("claims_schedule_detail", 
                {list:this.state.schedulelist[this.state.selectedIndex].schedule,
                staff:this.state.schedulelist[this.state.selectedIndex].staff_id,
                authenticator:ls.get("authenticator")});
        }
    }

    componentDidMount() {
        this._isMounted = true;  
        
        this.fetchSchedules();
        
        this.props.socket.on("schedule_list_result",(d)=>{
            if (this._isMounted) {
                //console.log(d);
                this.setState({schedulelist: d});
            }

            //console.log(this.state.sendclaimlist.length);
        });  

        this.props.socket.on("schedule_detail_result",(d)=>{
            //console.log(d);
            if (this._isMounted) {
                this.setState({scheduleclaimlist: d});
            }         
        });            

    }

    componentWillUnmount() {
        this._isMounted = false;
        this.props.socket.off("schedule_list_result");
        this.props.socket.off("schedule_detail_result");
    }

    handleChange = (event, value) => {
        this.setState({ value });
    };

    handleListItemClick = (event, index) => {
        this.setState({ selectedIndex: index }, () => this.fetchScheduleClaims());
    };

    renderScheduleList() {
        if (this.state.schedulelist)
        {
            return this.state.schedulelist.map((dt, i) => {
                return (
                    <ListItem
                        button
                        selected={this.state.selectedIndex === i}
                        onClick={event => this.handleListItemClick(event, i)}>
                        <ListItemText
                            primary={'Schedule '+dt.schedule}
                            secondary={dt.displayname}
                        />                            
                    </ListItem>
                );
            });
        }
        else
        {
            return;
        }
    }

    render() {
        const { classes } = this.props;
        const { schedulelist, scheduleclaimlist } = this.state;

        const columns=[
            { title: 'CRN', field: 'fp17_id'},
            { title: 'Surname', field: 'surname'},
            { title: 'Forename', field: 'forenames'},
            { title: 'Patient', field: 'ptchg'},
            { title: 'Schedule', field: 'ptchgsch'},
            { title: 'Remission', field: 'rmamt'},
            { title: 'Comment', field: 'comios'},
        ];    

        return (
        <div classname={classes.root}>
        <Grid container className={classes.gridStyle} spacing={1}>
            <Grid item xs={2}>
                <Paper>
                    <List dense className={classes.batchList}>
                        {this.renderScheduleList()}
                    </List>
                </Paper>            
            </Grid>     
            <Grid item xs={10}>
                <Paper>
                    <MuiThemeProvider theme={this.getMuiTheme()}>
                        <MaterialTable
                            columns={columns}
                            data={scheduleclaimlist}
                            title={'Claims in Schedule'}
                            options={{
                                exportButton: true,
                                selection: true,
                                pageSize: 10,
                            }}
                        />   
                    </MuiThemeProvider> 
                </Paper>            
            </Grid>               
        </Grid>
        </div>
        );
    }
}

export default withStyles(styles)(ClaimsSchedules);